/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import { Box, useTheme } from '@mui/material'
import { SideDrawer } from '@app/components/Molecules/SideDrawer'
import { useLiveMap } from './contexts/Live.MapContext'
import { LiveContextProvider } from './contexts/Live.Context'
import { LiveMapView } from './components/Live.MapView'
import { livePageContainer, sideDrawerContainer } from './Live.page.styles'
import { InformativePanel } from '@app/components/Molecules/RiskSideDrawerContent/tabs'

export const RexLivePage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const theme = useTheme()
  const mapContext = useLiveMap()
  const { map, setMapPadding, flyTo, getMapPadding } = mapContext

  return (
    <LiveContextProvider>
      <Box css={livePageContainer} id="livePageContainer">
        <Box css={sideDrawerContainer}>
          <SideDrawer
            isOpen={isDrawerOpen}
            mapContext={mapContext}
            handleToggle={() => setIsDrawerOpen((open) => !open)}
            color={theme.palette.primary.main}
            side="left"
            initialWidth={600}
            handleWidthChange={(width: number) => {
              const { left: previousWidth } = getMapPadding(true)
              setMapPadding({ top: 0, left: width, bottom: 0, right: 0 })

              if (map && width !== previousWidth) {
                flyTo({
                  latitude: map.getCenter().lat,
                  longitude: map.getCenter().lng,
                  zoom: map.getZoom(),
                  usePadding: true,
                  duration: 800,
                })
              }
            }}
          >
            <InformativePanel />
          </SideDrawer>
        </Box>
        <LiveMapView />
      </Box>
    </LiveContextProvider>
  )
}
